import type { AxiosError } from 'axios'

import { useCommonStore } from '@shared/model'
import { amplitudeConfig, trackEvent } from '@shared/lib/amplitude'

interface ReturnTrackRequest {
  trackSuccess: (props?: Record<string, any>) => void
  trackError: (err: AxiosError) => void
  trackErrorMessage: (message: string) => void
}

export const useTrackRequest = (name: string): ReturnTrackRequest => {
  const commonStore = useCommonStore()

  const track = (event: string, props?: Record<string, any>): void => {
    trackEvent(event, {
      name,
      page_type: commonStore.getPageType,
      ...props,
    })
  }

  const trackSuccess = (props?: Record<string, any>): void =>
    track(amplitudeConfig.events.requestSuccess, props)

  const trackError = (err: AxiosError): void =>
    track(amplitudeConfig.events.requestError, { code: err?.code, message: err?.message || 'Unexpected error' })

  const trackErrorMessage = (message: string): void =>
    track(amplitudeConfig.events.requestError, { message })

  return {
    trackSuccess,
    trackError,
    trackErrorMessage,
  }
}
